import axios from "axios";
import React, { useState, useEffect } from "react";
import styles from "../AppBundle.module.css";
import { readableDate } from "../helper/dateToRedable";
import BundleUpload from "../Bundleupload";

export const BundleHistory = ({ apps }) => {
  const { app_id } = apps;
  const url = `${process.env.REACT_APP_URL}`;

  //   console.log("history", apps);

  const [uploadedBundles, setUploadedBundles] = useState(null);

  useEffect(() => {
    appBundleHistory();
  }, []);

  const appBundleHistory = async () => {
    try {
      console.log(`${url}/auth/appBundleHistory?app_id=${app_id}`);
      const response = await axios.get(
        `${url}/auth/appBundleHistory?app_id=${app_id}`,
        {
          withCredentials: true,
        }
      );
      console.log("response :", response.data);
      setUploadedBundles(response.data.data);
    } catch (e) {
      console.log(e);
    } finally {
      console.log("finally here");
    }
  };

  const cellStyle = {
  padding: "10px",
  textAlign: "left",
};

  return (
    <div>
      <h1> history</h1>
      {uploadedBundles && uploadedBundles.length > 0 ? (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
          }}
        >
          <thead>
            <tr style={{ background: "#f2f2f2" }}>
              <th style={cellStyle}>Bundle Version</th>
              <th style={cellStyle}>App Version</th>
              <th style={cellStyle}>Stage</th>
              <th style={cellStyle}>Size</th>
              <th style={cellStyle}>Uploaded</th>
            </tr>
          </thead>

          <tbody>
            {uploadedBundles.map((item) => (
              <tr key={item.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={cellStyle}>{item.bundle_version}</td>
                <td style={cellStyle}>{item.app_version}</td>
                <td style={cellStyle}>{item.stage} {item.stage === 'active' && <div style={{width:10,height:10,backgroundColor:'green',borderRadius:20}}/>}</td>
                <td style={cellStyle}>
                  {(item.bundle_size / 1048576).toFixed(2)} MB
                </td>
                <td style={cellStyle}>
                  {new Date(item.upload_date).toLocaleString("en-IN")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No bundle history found.</p>
      )}
    </div>
  );
};
